import React from "react";
import Skeleton from "@mui/material/Skeleton";
import CloseIcon from "@mui/icons-material/Close";

function ListingSkeleton({ handleClose }) {
  return (
    <div className="flex flex-col h-full bg-[#FFFFFF] text-[#1E222B] relative">
      <div className="relative h-[255px] md:h-[270px] w-full bg-gray-900 select-none overflow-hidden flex-shrink-0">
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
          sx={{ bgcolor: "#2A2D34" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/85 pointer-events-none" />
        <div className="absolute top-4 left-4 right-4 flex items-center justify-between z-10">
          <button
            type="button"
            onClick={handleClose}
            className="w-9 h-9 rounded-full bg-black/55 hover:bg-black/80 backdrop-blur-xs flex items-center justify-center text-white cursor-pointer transition-transform active:scale-95 shadow-sm"
            aria-label="Close drawer"
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </button>
          <div className="flex items-center gap-2">
            <Skeleton
              variant="circular"
              width={36}
              height={36}
              sx={{ bgcolor: "rgba(255,255,255,0.15)" }}
            />
            <Skeleton
              variant="circular"
              width={36}
              height={36}
              sx={{ bgcolor: "rgba(255,255,255,0.15)" }}
            />
          </div>
        </div>
        <div className="absolute bottom-4 left-4 right-4 z-10 space-y-2">
          <Skeleton
            variant="rounded"
            width={55}
            height={20}
            sx={{ borderRadius: "4px", bgcolor: "rgba(255,255,255,0.2)" }}
          />
          <Skeleton variant="text" width="70%" height={32} sx={{ bgcolor: "rgba(255,255,255,0.2)" }} />
          <Skeleton variant="text" width="45%" height={18} sx={{ bgcolor: "rgba(255,255,255,0.2)" }} />
        </div>
      </div>

      <div className="bg-[#18191B] text-white px-6 py-3.5 flex items-center justify-between select-none">
        <div>
          <p className="text-[#999FA9] text-[11px] font-[500]">Per Unit</p>
          <Skeleton
            variant="text"
            width={75}
            height={22}
            sx={{ bgcolor: "#2A2D34" }}
          />
        </div>
        <div className="text-center flex flex-col items-center">
          <p className="text-[#999FA9] text-[11px] font-[500]">Remaining</p>
          <Skeleton
            variant="text"
            width={60}
            height={22}
            sx={{ bgcolor: "#2A2D34" }}
          />
        </div>
        <div className="text-right flex flex-col items-end">
          <p className="text-[#999FA9] text-[11px] font-[500]">Area</p>
          <Skeleton
            variant="text"
            width={65}
            height={22}
            sx={{ bgcolor: "#2A2D34" }}
          />
        </div>
      </div>
      <div className="flex items-center border-b border-gray-100 bg-white px-6 py-3 gap-8">
        <Skeleton variant="text" width={65} height={24} />
        <Skeleton variant="text" width={45} height={24} />
        <Skeleton variant="text" width={40} height={24} />
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        <div className="bg-white rounded-2xl border border-[#F1F5F9] p-4 shadow-2xs space-y-3">
          <div className="flex justify-between items-center">
            <Skeleton variant="text" width={110} height={20} />
            <Skeleton variant="text" width={35} height={20} />
          </div>
          <Skeleton
            variant="rounded"
            width="100%"
            height={8}
            sx={{ borderRadius: "999px" }}
          />
        </div>

        <div className="bg-white rounded-2xl border border-[#F1F5F9] p-4 shadow-2xs space-y-3">
          <Skeleton variant="text" width={110} height={22} />
          <div className="space-y-2.5 pt-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex justify-between items-center">
                <Skeleton variant="text" width={95} height={18} />
                <Skeleton variant="text" width={75} height={18} />
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-[#F1F5F9] p-3.5 shadow-2xs flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Skeleton
              variant="rounded"
              width={40}
              height={40}
              sx={{ borderRadius: "12px" }}
            />
            <div className="space-y-1">
              <Skeleton variant="text" width={110} height={18} />
              <Skeleton variant="text" width={80} height={14} />
            </div>
          </div>
          <Skeleton variant="text" width={90} height={20} />
        </div>

        <div className="space-y-1.5 px-1">
          <Skeleton variant="text" width="100%" height={16} />
          <Skeleton variant="text" width="90%" height={16} />
          <Skeleton variant="text" width="70%" height={16} />
        </div>
      </div>

      <div className="p-4 pt-3 bg-white border-t border-gray-100 flex flex-col items-center flex-shrink-0">
        <Skeleton
          variant="rounded"
          width="100%"
          height={48}
          sx={{ borderRadius: "12px" }}
        />
        <Skeleton variant="text" width={150} height={14} sx={{ mt: 1 }} />
      </div>
    </div>
  );
}

export default ListingSkeleton;
